import { CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import React, { useState } from 'react'
import taskActivityServices from '../taskActivityServices';
import taskServices from '../taskServices';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment';
import { ZoomIn } from '@mui/icons-material';

function TaskDetails({taskId,taskTitle}) {
    const {getMasterLabel} = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [activityList,setActivityList] = useState(null);

    const [taskDetails,setTaskDetails] = useState(null);

    const [loading,setLoadingStatus] = useState(false);

    
    const getActivityList = () =>{
        taskActivityServices.getByTaskId(taskId).then(res=>{
            setActivityList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }
    
    const getTaskDetails = () =>{
        setLoadingStatus(true);
        setDialogStatus(true);
        taskServices.getById(taskId).then(res=>{
            setTaskDetails(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    return (
    <>
        <div type="button" className='p-0 btn-link text-dark' onClick={getTaskDetails} >{taskTitle === undefined ? "Show Details": taskTitle}</div>
        <Dialog
            open={dialogStatus}
            keepMounted
            onClose={()=>setDialogStatus(false)}
            fullWidth={true}
            maxWidth="md"
        >
            {loading && <div className='text-center p-5'><CircularProgress/></div>}
            {!loading && taskDetails &&
            <>
                <DialogTitle>{taskDetails.title}</DialogTitle>
                <DialogContent>{taskDetails.details}
                    {!activityList &&
                        <div className='text-center'><button className='btn btn-outline-primary' onClick={getActivityList} > Show Activity </button></div>
                    }
                    {activityList &&
                    <table className='table mt-3'>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Progress</th>
                                <th>Status</th>
                                <th>Remark</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityList.map(activity=>
                                <tr>
                                    <th>{moment(activity.updated_at).fromNow()}</th>
                                    <td>{activity.progress} %</td>
                                    <td>{ getMasterLabel("task-status",activity.status )}</td>
                                    <td>{activity.remark == "" ? "--":activity.remark}</td>
                                    <td>{moment(activity.updated_at).format("LLLL")}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    }
                </DialogContent>
            
            </>
            }
        </Dialog>
    </>
    )
}

export default TaskDetails